import React from "react";

import {
    SearchFacetsState,
} from "../interfaces/context/searchFacetsContextInterfaces";

const defaultSearchFacetsState: SearchFacetsState = {
    companyFacets: {
        perks_and_benefits: []
    }
};

const SearchFacetsStateContext = React.createContext<SearchFacetsState | undefined>(defaultSearchFacetsState);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchFacetProvider>
 *   <Component />
 * </SearchFacetProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchFacetsState();
 * ```
 */
const SearchFacetsProvider: React.FC<React.PropsWithChildren<SearchFacetsState>> = (props) => {
    const { children, companyFacets } = props;
    return (
        <SearchFacetsStateContext.Provider value={{ companyFacets }}>
            {children}
        </SearchFacetsStateContext.Provider>
    );
};

const useSearchFacetsState = () => {
    const context = React.useContext(SearchFacetsStateContext);
    if (context === undefined) {
        throw new Error("useSearchFacetsState must be used within the SearchFacetsProvider.");
    }
    return context;
};

SearchFacetsProvider.displayName = "SearchFacetsProvider";
useSearchFacetsState.displayName = "useSearchFacetsState";

export { SearchFacetsProvider, useSearchFacetsState };
